import { iono } from 'global';

/**
 * Retrieve a transcript link from a playlist items list of links
 *
 * @param {Object} playlistItem A playlist item
 * @returns {Object|null} A link of kind 'transcript' or null if one is not present
 */
export function getTranscriptLink (playlistItem) {
  for (const link of playlistItem.links) {
    if (link.kind === 'transcript') {
      return link;
    }
  }

  return null;
}

/**
 *
 * @param {Object} link
 * @returns {Object|null}
 */
export async function loadTranscriptLink (link) {
  try {
    const vttDataString = await iono.Player.Utils.fetchVttData(link);
    const vttData = await iono.Player.Utils.parseVttData(vttDataString);

    return vttData;
  } catch (e) {
    console.error(`Failed to load VTT data: ${e.message}`);
  }

  return null;
}
